
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.TeamFoundation.Common
//----------------------------------------------------------


/**
* URL-related constants.
*/
export module UrlConstants {
    /**
    * Approved list of URL schemes.
    */
    export var SafeUriSchemes = ["http", "https", "ftp", "gopher", "mailto", "news", "telnet", "wais", "vstfs", "tfs", "alm", "mtm", "mtms", "mtr", "mtrs", "mfbclient", "mfbclients", "test-runner", "x-mvwit", "onenote", "codeflow", "file", "tel", "skype"];
}

